import { createContext } from 'react';

export const ShellContext = createContext(false);
